import type {
  RecurringDonationSeries,
  RecurringStatus,
} from '@/types/recurringDonation'

/**
 * Active schedules first, soonest next date first, then stopped, then
 * completed. A missing next date sorts after dated schedules in the same
 * status. Charity name breaks remaining ties.
 */
const STATUS_RANK: Record<RecurringStatus, number> = {
  active: 0,
  stopped: 1,
  completed: 2,
}

export function compareRecurringSeriesForList(
  a: RecurringDonationSeries,
  b: RecurringDonationSeries
): number {
  const byStatus = STATUS_RANK[a.status] - STATUS_RANK[b.status]
  if (byStatus !== 0) return byStatus

  const aDate = a.nextDonationDate ?? ''
  const bDate = b.nextDonationDate ?? ''
  if (aDate !== bDate) {
    if (!aDate) return 1
    if (!bDate) return -1
    return aDate < bDate ? -1 : 1
  }

  return a.charity.localeCompare(b.charity, 'en-GB')
}

export function sortRecurringSeriesForList(
  series: RecurringDonationSeries[]
): RecurringDonationSeries[] {
  return [...series].sort(compareRecurringSeriesForList)
}
